<bit-callout type="info" [title]="'prerequisite' | i18n">
  {{ "accountRecoveryPolicySingleOrgReqV2" | i18n }}
</bit-callout>

@if (showKeyConnectorInfo$ | async) {
  <bit-callout type="info">
    {{ "keyConnectorPolicyRestriction" | i18n }}
  </bit-callout>
}

<p>
  {{ "accountRecoveryPolicyDescV3Part1" | i18n
  }}<a
    bitLink
    href="https://bitwarden.com/help/account-recovery/"
    target="_blank"
    rel="noreferrer"
    >{{ "accountRecoveryDescLinkText" | i18n }}</a
  >{{ "accountRecoveryPolicyDescV3Part2" | i18n }}
</p>

<bit-form-control>
  <bit-switch [formControl]="enabled" id="enabled"></bit-switch>
  <bit-label>{{ "enablePolicy" | i18n }}</bit-label>
</bit-form-control>

<ng-container [formGroup]="data">
  <bit-form-control>
    <input type="checkbox" bitCheckbox formControlName="autoEnrollEnabled" id="autoEnrollEnabled" />
    <bit-label>{{ "resetPasswordPolicyAutoEnrollCheckboxV2" | i18n }}</bit-label>
  </bit-form-control>
</ng-container>
